import { Component, OnInit, ViewEncapsulation, HostBinding, Input } from '@angular/core';
import { AccountConfigService } from '../../../services/account-config/account-config.service';
import { SessionService } from '../../../services/session/session.service';
import { MFormation } from '@argalis-apps/models';

@Component({
  selector: 'ags-session-sous-titre',
  templateUrl: './session-sous-titre.component.html',
  styleUrls: ['./session-sous-titre.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SessionSousTitreComponent implements OnInit {
  @HostBinding('class') themeFlag = 'account-theme';
  public headerData: any;
  public open = false;
  public popupError = false;
  public idSession;
  surchargeHeureAcadomia = { b_actif: false };
  public alerteVolumeHeure = '';
  public alerteVolumeHeureBar = '';
  @Input('idSession')
  set _idSession(value: string) {
    if (value) {
      this.idSession = value;
    }
  }

  constructor(private accountConfigService: AccountConfigService, private sessionService: SessionService) {}

  ngOnInit() {
    this.sessionService
      .moducleChecker('ACADOMIA_SURCHARGE_HORAIRE_SESSION')
      .subscribe(data => (this.surchargeHeureAcadomia = data[0]));
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
    this.getHeaderInfo(this.idSession);
  }

  getHeaderInfo(idSession) {
    this.sessionService.getSessionHeader(idSession).subscribe((headerData: any) => {
      this.headerData = headerData[0];
      if (this.headerData.duree.includes('-')) this.headerData.duree = '+' + this.headerData.duree;
      this.headerData.duree = this.headerData.duree.replaceAll('-', '');
      if (this.headerData) {
        if (Number(this.headerData.pourcentage_heure) > 100 || this.headerData.duree.includes('+')) {
          this.alerteVolumeHeure = 'color-hours';
          this.alerteVolumeHeureBar = 'color-hours-bar';
        } else {
          this.alerteVolumeHeure = '';
          this.alerteVolumeHeureBar = '';
        }
      }
    });
  }

  public close() {
    this.open = false;
    this.popupError = false;
  }

  async openPopup() {
    this.open = true;
  }

  closeSession() {
    const sessionId = {
      idSession: this.idSession,
      idIntervenant: '159'
    };
    this.open = false;
    this.sessionService.updatecloseSession(sessionId).subscribe(
      () => {
        this.getHeaderInfo(this.idSession);
      },
      error => {
        this.errorPopup();
      }
    );
  }

  errorPopup() {
    this.popupError = true;
  }
}
